import { makeStyles }      from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  logo: {
    height: '2.5rem',
  },
}));

export default useStyles;